<div class="wrapper__form container my-5 border__form">
  <!--Formulario administrador líder-->
  <app-form
    *ngIf="esAdminLider"
    [title]="'crear-administrador.actualizar-lider' | translate"
    [fields]="camposAdminLider"
    [withSubmitButton]="true"
    (submitAction)="onSubmitAdminLider($event)">
  </app-form>

  <!--Formulario administrador funcional-->
  <app-form
    *ngIf="esAdminFuncional"
    [title]="'crear-administrador.actualizar-funcional' | translate"
    [fields]="camposAdminFuncional"
    [withSubmitButton]="true"
    (submitAction)="onSubmitAdminFuncional($event)">
  </app-form>

  <button
    type="button"
    class="btn-govco outline-btn-govco hvr-shrink w-25"
    style="cursor: pointer"
    (click)="onSubmitResetContrasena()"
    tabindex="0"
    [attr.aria-label]="'password.restablecer_password' | translate">
    {{'password.restablecer_password' | translate}}
  </button>
</div>
